var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.614 2.616c.245-.3.614-.47 1-.46.34.009.595.178.724.27a6.866 6.866 0 0 1 .472.385l7.075 6.064c.087.075.188.161.27.244.092.094.22.243.298.458a1.25 1.25 0 0 1 0 .846 1.261 1.261 0 0 1-.299.458c-.081.083-.182.17-.27.244l-7.097 6.084a6.782 6.782 0 0 1-.45.365c-.128.091-.384.261-.723.27a1.25 1.25 0 0 1-1-.46c-.214-.263-.251-.568-.266-.725-.015-.168-.015-.374-.015-.578v-2.584A8.669 8.669 0 0 0 3.141 16.5a.833.833 0 0 1-1.474-.532v-.51a8.89 8.89 0 0 1 6.666-8.602V3.92c0-.204 0-.41.015-.578.015-.157.052-.462.266-.725Z",
    fill: "#1e3d98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoRight);
export default __webpack_public_path__ + "static/media/go-right.16abfaa8b1e6f90789dddaf6959fbec5.svg";
export { ForwardRef as ReactComponent };